import React, { useEffect, useRef } from "react";
import { useAddSynergyAttachmentMutation } from "../../../../../../../app/services/projectSynergyAPI";
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import { synergyattachmentForm } from "./config/synergyAttachments.Data";
import ToastService from "../../../../../../../services/toastService/ToastService";

const AddsynergyAttachments = ({ synergyId, onClose }) => {
  const fileref = useRef();

  const [
    addSynergyAttachment,
    {
      isSuccess: isaddSynergyAttachmentAdded,
      isLoading: isaddSynergyAttachmentAdding,
      data: addSynergyAttachmentData,
    },
  ] = useAddSynergyAttachmentMutation();

  const handleFileFieldBlur = (dataField, updatedValue) => {
    const fileAttachment = updatedValue?.[dataField];

    if (fileAttachment) {
      let request = {
        FileName: fileAttachment[0].fileName,
        StoragePath: fileAttachment[0].file.type,
        base64File: fileAttachment[0].base64Data,
        synergyId: synergyId,
      };
      addSynergyAttachment(request);
    }
  };

  useEffect(() => {
    if (isaddSynergyAttachmentAdded && addSynergyAttachmentData) {
      if (addSynergyAttachmentData.errorMessage.includes("exists")) {
        ToastService.warning(addSynergyAttachmentData.errorMessage);
        return;
      } else {
        ToastService.success(addSynergyAttachmentData.errorMessage);
        onClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isaddSynergyAttachmentAdded, addSynergyAttachmentData]);

  return (
    <FormCreator
      config={synergyattachmentForm}
      ref={fileref}
      onFieldBlure={handleFileFieldBlur}
      isLoading={isaddSynergyAttachmentAdding}
    />
  );
};

export default AddsynergyAttachments;
